import { useState } from 'react';
import { isNil } from 'lodash';
import { useTransformEvent } from '@ion/api';
import DEFAULT_PLAYBOOK from 'app/shared/translation/pipelines/DEFAULT_PLAYBOOK';

export default function usePipelineStageOutput({ deployedPipeline, clusterId }) {
  const [passthroughEvent, setPassthroughEvent] = useState(null);
  const [transformEvent, { loading, error, outputEvent: transformOutputEvent, errors, reset: resetTransformEvent }] =
    useTransformEvent();

  const transform = deployedPipeline?.transform;
  const filter = deployedPipeline?.filter;
  const shouldTransform = !isNil(transform) || !isNil(filter);

  const executePipelineTransform = ({ parsedInput }) => {
    if (shouldTransform) {
      transformEvent({
        // Tech Debt - See comment in DEFAULT_PLAYBOOK
        playbook: transform?.data.playbook ?? DEFAULT_PLAYBOOK,
        // First step of the chain: the input to the pipeline playbook IS the
        // original client event, so both fields carry the same value.
        inputEvent: parsedInput,
        originalEvent: parsedInput,
        pipelineFilter: filter,
        clusterId,
      });
    } else {
      // Never-deployed pipeline (or no pipeline-level transform/filter):
      // the pipeline stage is a passthrough.
      setPassthroughEvent(parsedInput);
    }
  };

  const outputEvent = shouldTransform ? transformOutputEvent : passthroughEvent;

  const reset = () => {
    setPassthroughEvent(null);
    resetTransformEvent();
  };

  return [executePipelineTransform, { loading, error, outputEvent, errors, reset, passthrough: !shouldTransform }];
}
